import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getComicsByCategory } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            <i className="ri-grid-line text-primary-500 mr-2"></i>
            热门分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">八大分类，总有一类适合你</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => {
            const count = getComicsByCategory(cat.slug).length;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group bg-background-50 rounded-lg p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 flex flex-col items-center text-center gap-2"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </div>
                <h3 className="font-heading text-sm md:text-base text-foreground-900">{cat.name}</h3>
                <p className="text-xs text-foreground-400 line-clamp-2">{cat.description}</p>
                <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">{count}部漫画</span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}